import mask from 'slim-mask-js'

export default (str) => mask(str, '####.####.####.####.####')
